import styled from 'styled-components';
import ArrowActiveSvg from '../../assets/mytrips/ic-arrowactive.svg';

const ArrowActiveIcon = styled(ArrowActiveSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '1.4rem'};
  height: ${props => props.height || '4rem'};
  margin: ${props => props.margin};
`;

export default ArrowActiveIcon;
